import { LoadingOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import type Template from 'stores/Template';

import DownloadButton from './DownloadButton';
import RemoveTemplateButton from './RemoveTemplateButton';
import UpdateTemplateButton from './UpdateTemplateButton';

const Container = styled.div`
  align-items: center;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: space-between;
  padding: 9px 16px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 7px;
`;

const MainLabel = styled.div<{ $loading: boolean }>`
  font-size: 14px;
  font-weight: bold;
  opacity: ${(p) => (p.$loading ? 0.5 : 1)};
`;

const DateLabel = styled.div`
  font-size: 12px;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 10px;
  color: #666;
`;

const LoadingIcon = styled(LoadingOutlined)`
  align-self: center;
  padding-right: 8px;
`;

export interface TemplateSummaryRowProps {
  template: Template;
}

function TemplateSummaryRow({ template }: TemplateSummaryRowProps) {
  return (
    <Container>
      <MainLabel $loading={template.loading}>{template.data.name}</MainLabel>

      <ButtonsContainer>
        {template.loading && <LoadingIcon />}
        <DateLabel>{template.formattedDateModified}</DateLabel>
        {template.downloadURL ? <DownloadButton template={template} /> : null}
        <UpdateTemplateButton template={template} />
        <RemoveTemplateButton template={template} />
      </ButtonsContainer>
    </Container>
  );
}

export default observer(TemplateSummaryRow);
